/**
 * DocumentCanvas - Stub component for web demo mode
 * In Office.js mode, the actual Word document is used instead
 */
import React from 'react';

const DocumentCanvas = ({ content, onSelection, onClearSelection, selectedText, selectionRange }) => {
  return (
    <div className="h-full bg-white p-8 overflow-auto">
      <div className="max-w-3xl mx-auto">
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-gray-700 mb-4">Demo Dokument</h3>
          <div 
            className="prose prose-sm max-w-none text-gray-600 whitespace-pre-wrap"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentCanvas;
